export const executionErrorMessages = {
  Deduction_missing:
    'Deduction missing - No deduction found for the donation. Reach out to support to roll over the deduction to the next pay cycle.',
  Deduction_not_found: 'Deduction not found',
  Deduction_failed:
    'Deduction failure - Deduction failed to be sent. Reach out to support for further action.',
  Deduction_event_creation_failed: 'Deduction event creation failed',
  Deduction_orphaned: 'Deduction orphaned',
  Deduction_retrying: 'Deduction retrying',
  Deduction_value_mismatch:
    'Deduction value mismatch - There was a mismatch in the deduction amount. Reach out to support for further action.',
};
